<template>
  <div class="form-elements">
    <div class="row">
      <div class="flex xs12">
        <va-card :title="$t('menu.pallet_type_setups') + ' ' + this.$route.params.pallet_type_name +  ' de ' + this.$store.state.currentLocality.name">
          <form @submit.prevent>
            <div class="row">

              <div class="flex md2 sm3 xs4">
                <va-input
                  v-model="pallet_type_setup.minimal_cubage"
                  :label="$t('forms.inputs.minimal_cubage')"
                >
                </va-input>
              </div>

              <div class="flex md2 sm3 xs4">
                <va-input
                  v-model="pallet_type_setup.maximal_cubage"
                  :label="$t('forms.inputs.maximal_cubage')"
                >
                </va-input>
              </div>

              <div class="flex md2 sm3 xs4">
                <va-input
                  v-model="pallet_type_setup.minimal_vehicle_percentage"
                  :label="$t('forms.inputs.minimal_vehicle_percentage')"
                >
                </va-input>
              </div>

              <div class="flex md2 sm3 xs4">
                <va-toggle
                  v-model="pallet_type_setup.quantity_limitation"
                  :label="$t('tables.pallet_type_setups.quantity_limitation')"
                  :color="$themes.secondary"
                  small
                />
              </div>

              <div class="flex md2 sm3 xs4" v-if="this.pallet_type_setup.quantity_limitation === true">
                <va-input
                  v-model="pallet_type_setup.limit_quantity"
                  :label="$t('forms.inputs.limit_quantity')"
                >
                </va-input>
              </div>

              <div class="flex md2 sm3 xs4">
                <va-toggle
                  v-model="pallet_type_setup.specific_products"
                  :label="$t('tables.pallet_type_setups.specific_products')"
                  :color="$themes.secondary"
                  small
                  @input="save()"
                />
              </div>
            </div>
            <div class="row">
              <div class="flex sm6 xs12">
                <va-button
                  medium
                  inline
                  color="secondary"
                  icon="fa fa-save"
                  class="mr-1"
                  @click="saveAndGoBack()"
                >
                  {{ $t('menu.update') }}
                </va-button>

                <va-button
                  medium
                  inline
                  color="#ff842b"
                  icon="fa fa-chevron-left"
                  class="mr-1"
                  :to="{ name: 'pallets' }">
                  {{ $t('menu.back') }}
                </va-button>

                <va-button
                  v-if="this.pallet_type_setup.specific_products === true"
                  medium
                  inline
                  color="green"
                  icon="fa fa-plus"
                  class="mr-1"
                  :to="{ name: 'form-pallet-products', params: { id: this.$route.params.id, pallet_type_name: this.$route.params.pallet_type_name } }">
                  {{ $t('tables.pallet_type_setups.add_products') }}
                </va-button>
              </div>
            </div>
          </form>
        </va-card>
      </div>
    </div>
  </div>
</template>

<script>
import PalletTypeSetupAPI from '@/services/PalletTypeSetupAPI'
import { mapState } from 'vuex'

export default {
  name: 'form-pallet-type-setup',
  data () {
    return {
      pallet_type_id: '',
      renderComponent: true,
      loading: false,
      pallet_type_setup: {
        id: '',
        quantity_limitation: false,
        limit_quantity: '',
        minimal_cubage: '',
        maximal_cubage: '',
        specific_products: false,
        minimal_vehicle_percentage: '',
      },
    }
  },

  computed: {
    ...mapState(['currentUser', 'currentLocality']),
  },

  mounted () {
    this.readItems()
  },

  watch: {
    '$store.state.currentLocality': function () {
      this.readItems()
    },
  },

  methods: {
    async readItems () {
      this.pallet_type_setup.pallet_type_id = this.$route.params.id
      this.pallet_type_setup.locality_id = this.$store.state.currentLocality.id

      PalletTypeSetupAPI.getPalletTypeSetupByPalletTypeAndLocality(this.pallet_type_setup).then(response => {
        this.pallet_type_setup = response.data.pallet_type_setup
      }).catch(e => {
        this.resetLables()
      })
    },

    save () {
      if (this.pallet_type_setup.id === '' || this.pallet_type_setup.id === undefined) {
        PalletTypeSetupAPI.createPalletTypeSetup(this.pallet_type_setup).then(response => {
          this.showToast(response.data.message, {
            icon: 'fa-thumbs-o-up',
            position: 'top-right',
            duration: 5000,
          })
          this.readItems()
        }).catch(e => {
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
        })
      } else {
        PalletTypeSetupAPI.updatePalletTypeSetup(this.pallet_type_setup).then(response => {
          this.showToast(response.data.message, {
            icon: 'fa-thumbs-o-up',
            position: 'top-right',
            duration: 5000,
          })
          this.readItems()
        }).catch(e => {
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
        })
      }
    },

    goBack () {
      this.$router.push({
        name: 'pallets',
      })
    },

    saveAndGoBack () {
      this.save()
      this.goBack()
    },

    onPageChange (page) {
      this.readProducts(page)
    },

    forceRerender () {
      this.renderComponent = false

      this.$nextTick(() => {
        this.renderComponent = true
      })
    },

    resetLables () {
      this.pallet_type_setup.id = ''
      this.pallet_type_setup.quantity_limitation = false
      this.pallet_type_setup.limit_quantity = ''
      this.pallet_type_setup.minimal_cubage = ''
      this.pallet_type_setup.maximal_cubage = ''
      this.pallet_type_setup.specific_products = false
      this.pallet_type_setup.minimal_vehicle_percentage = ''
    },
  },
}
</script>
